import { CampaignCreateContext, CampaignCreateContextType } from '@/pages/campaign/CreatePage/context';
import { useContext } from 'react';

export const useCampaignCreateContext = (): CampaignCreateContextType => {
    const context = useContext(CampaignCreateContext);

    if (!context) {
        throw new Error('useCampaignCreateContext must be used within a CampaignCreateContextProvider');
    }

    return context;
};
